module.exports = __webpack_public_path__ + "1420948ff1427581851b4c24e954a549.pdf";